// extracted by mini-css-extract-plugin
module.exports = {"header":"Subsection_header__3SdJV","section":"Subsection_section__2r6Mq"};